import { InstrumentState } from "./instrument-state";

export enum HardwareTypes {
    NONE = 0,

    SaxHall = 0x01,

    SaxHallWithSound = 0x02,

    SaxOptical = 0x03,

    Clarinet = 0x10,

    NINA = 0x1001,

    SOUNDBANK_MS = 0x1002
}

export interface InstrumentType {

  id: string,

  type: HardwareTypes,
  version: number,

  title: string,

  ninaVersion?: string;
}

export function lookupInstrument(type: HardwareTypes, version: number) : InstrumentType | undefined {
  return INSTRUMENT_TYPES.find( value => ((value.type == type) && (value.version == version)));
}

export const INSTRUMENT_TYPES: InstrumentType[] = [

  {
    id: 'EMEO_SAX_V1',

    type: HardwareTypes.SaxHall,
    version: 1,
    
    title: 'EMEO Digital Saxophone MK1'
  }, 

  {
    id: 'EMEO_SAX_V2',

    type: HardwareTypes.SaxHallWithSound,
    version: 1,
    
    title: 'EMEO Digital Saxophone MS'
  }, 

  {
    id: 'EMEO_SAX_VOYAGER',

    type: HardwareTypes.SaxOptical,
    version: 2,
    
    title: 'EMEO Voyager'
  }, 

  {
    id: 'EMEO_CLARINET_V2',

    type: HardwareTypes.Clarinet,
    version: 1,

    title: 'EMEO Digital Clarinet'
  }
]

export class HardwareInfo {

  type: HardwareTypes;
  
  version: number;
  
  serialNumber: string;
  
  circuitSerialNumber: string;
  
  deviceDate: Date;

  constructor(
    hardwareType: HardwareTypes,
    hardwareVersion: number,
    hardwareSerialNumber: string,
    circuitSerialNumber: string,
    deviceDate: Date) {

    this.type = hardwareType;
    this.version = hardwareVersion;
    this.serialNumber = hardwareSerialNumber;
    this.circuitSerialNumber = circuitSerialNumber;
    this.deviceDate = deviceDate;
  }  
}

export class DeviceInfo {

  hardware: HardwareInfo;

  firmwareVersion: string;

  ninaVersion?: string;

  constructor(
    hardware: HardwareInfo,
    firmwareVersion: string) {

    this.hardware = hardware;
    this.firmwareVersion = firmwareVersion;
  }
}

export interface InstrumentConnectionInfo {
  get deviceInfo() : DeviceInfo;

  get deviceState() : InstrumentState;
}

export const NO_DEVICE = new HardwareInfo(HardwareTypes.NONE, 0, '', '', new Date(0));

// Sax Hall original    - HWType = 0x01     HWVersion  = 0x01
export const EMEO_SAX_V1 = new HardwareInfo(HardwareTypes.SaxHall, 1, '', '', new Date(2021, 1, 1));

// Sax Hall with sound  - HWType = 0x02      HWVersion  = 0x01
export const EMEO_SAX_V2 = new HardwareInfo(HardwareTypes.SaxHallWithSound, 1, '', '', new Date(2025, 10, 1));

// Clarinet Optical     - HWType = 0x10     HWVersion  = 0x02
export const EMEO_CLARINET_V1 = new HardwareInfo(HardwareTypes.Clarinet, 2, '', '', new Date(2026, 1, 1));

// Sax Optical (voyager) - HWType = 0x02     HWVersion  = 0x02
export const EMEO_VOYAGER_V1 = new HardwareInfo(HardwareTypes.SaxOptical, 2, '', '', new Date(2026, 1, 1));

export const DEV_NO_DEVICE = new DeviceInfo(new HardwareInfo(HardwareTypes.NONE, 0, '', '', new Date(0)), '');
export const DEV_EMEO_SAX_V1_202 = new DeviceInfo(new HardwareInfo(HardwareTypes.SaxHall, 1, '', '', new Date(2020, 10, 1)), '<UNKNOWN>');
export const DEV_EMEO_CLARINET_V1 = new DeviceInfo(new HardwareInfo(HardwareTypes.Clarinet, 2, '', '', new Date(2024, 1, 1)), '<UNKNOWN>');

export const HARDWARE_INFOS: HardwareInfo[] = [
  
  EMEO_SAX_V1,
  EMEO_SAX_V2,

  EMEO_VOYAGER_V1,
  
  EMEO_CLARINET_V1
];


